/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-use-before-define */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable max-len */
/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import * as React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Icon from "../../../components/Icon";
import {
  EDIT_ICON,
  BODY_TEXT_NAVY_2,
  EMPTY_PROFILE_PIC,
  TextRegularS,
  OffWhiteBackground,
  Body3300N,
  Body3400C,
  Body3300C,
} from "../../../utilities/generatedClasses";
import { classNameTriskeleParser } from "../../../utilities/customStyles";
import ClientSkeleton, { EmptyData } from "./skeleton/ClientListSkeleton";
import EmptyState from "../../../components/EmptyState";
import PermissionsCard, {
  PermissionsCardMobile,
} from "../../../components/PermissionsCard";
import { connectionStatuses, permissionFilter } from "../../../utilities/utils";
import { cleanData, debounce, sortItems } from "../../../utilities/utils";
import SearchCard from "../../../components/SearchCard";
import ClientAccess from "../../../dataAccess/ClientAccess";
import ProfileHeader from "../../../components/header/ProfileHeader";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Radio,
  FormControlLabel,
  RadioGroup,
  FormControl,
  Checkbox,
  Card,
  CardContent,
  Typography,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ClientListSkeletonMobile from "./skeleton/ClientListSkeletonMobile";
import { toast } from "react-toastify";

export default function ClientListView(props) {
  const [header, setHeader] = useState(null);
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [skeleton, setSkeleton] = useState(true);
  const [clonedData, setClonedData] = useState([]);

  const [editDialogItem, setEditDialogItem] = useState(null);
  const [isEditDialogItemOpen, setEditDialogItemOpen] = useState(false);
  const [selectedPermission, setSelectedPermission] = useState(null);
  const [connectionStatus, setConnectionStatuses] =
    useState(connectionStatuses);
  const [selectedFilter, setFilter] = useState(null);
  const [selectedPermissionFilter, setPermissionFilter] =
    React.useState(permissionFilter);

  const [keyword, setKeyword] = useState("");

  const { clickedData } = props;

  const [sortedItems, setSortedItems] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState(null);
  const navigate = useNavigate();

  // Sort By FirstName/LAstName/PreferredName
  const sortData = (datakey) => {
    setSkeleton(true);
    setData([]);
    let dataSortedItems;
    if (
      sortedItems &&
      sortedItems.datakey === datakey &&
      sortedItems.order === 1
    ) {
      dataSortedItems = sortItems(data, datakey, -1);
      setSortedItems({ datakey, order: -1 });
    } else {
      dataSortedItems = sortItems(data, datakey, 1);
      setSortedItems({ datakey, order: 1 });
    }
    setData(dataSortedItems);
    setSkeleton(false);
  };

  const filterData = (datakey, filterType, searchText) => {
    setTimeout(() => {
      if (filterType === "search") {
        setSkeleton(true);
        ClientAccess.searchUsers(searchText).then((response) => {
          const clients = response.data.filter(
            (x) => x.PrcsParmtrValueOne === "Clients",
          );
          const headerResponse = response.data.find(
            (x) => x.PrcsParmtrValueOne === "Title",
          );
          const columnsResponse = response.data.find(
            (x) => x.PrcsParmtrValueOne === "Column Headers",
          );
          columnsResponse.ColumnHeaderArray = cleanData(
            columnsResponse.ColumnHeaderArray,
          );
          for (let i = 0; i < clients.length; i += 1) {
            clients[i].ClientInformationArray = cleanData(
              clients[i].ClientInformationArray,
            );
          }

          setData(clients);
          setHeader(headerResponse);
          setColumns(columnsResponse);
          if (!searchText) {
            setClonedData(clients);
          }
          setSkeleton(false);
        });
      }
      // Need To check header column type
      else if (filterType === 0 || filterType === 1 || filterType === 2) {
        sortData(datakey);
      } else if (datakey === selectedFilter) {
        setFilter(null);
      } else {
        setFilter(datakey);
      }
    }, 0);
  };

  useEffect(() => {
    filterData(null, "search");
  }, []);

  useEffect(() => {
    removeSelectedFilter();
  }, [clickedData]);

  // filter data by selected permissions status
  const filterByPermissions = (index, permission) => {
    const selectedpermissionsFilter = [...selectedPermissionFilter];
    selectedpermissionsFilter[index].value = permission;

    const lifestyleDataValue =
      selectedpermissionsFilter[0].value === "Enabled"
        ? "TRUE"
        : selectedpermissionsFilter[0].value === "Disabled"
          ? "FALSE"
          : "All";
    const medicalDataValue =
      selectedpermissionsFilter[1].value === "Enabled"
        ? "TRUE"
        : selectedpermissionsFilter[1].value === "Disabled"
          ? "FALSE"
          : "All";
    const sharingValue =
      selectedpermissionsFilter[2].value === "Enabled"
        ? "TRUE"
        : selectedpermissionsFilter[2].value === "Disabled"
          ? "FALSE"
          : "All";

    const allData = [...clonedData];
    const filteredData = [];

    for (let i = 0; i < allData.length; i += 1) {
      const lifestylePermission =
        allData[i].ClientInformationArray[0].Permissions[0];
      const medicalPermission =
        allData[i].ClientInformationArray[0].Permissions[1];
      const sharingPermission =
        allData[i].ClientInformationArray[0].Permissions[2];

      if (
        (lifestylePermission.PermissionValue === lifestyleDataValue ||
          lifestyleDataValue === "All") &&
        (medicalPermission.PermissionValue === medicalDataValue ||
          medicalDataValue === "All") &&
        (sharingPermission.PermissionValue === sharingValue ||
          sharingValue === "All")
      ) {
        filteredData.push(allData[i]);
      }
    }

    setData(filteredData);
    setPermissionFilter(selectedpermissionsFilter);
  };
  // filter data by selected connection statuses
  const filterByConnectionStatus = (selectedConnectionStatus) => {
    const connectionsStatuses = [...connectionStatus];

    const selectedItem = connectionsStatuses.find(
      (x) => x.value === selectedConnectionStatus.value,
    );

    selectedItem.checked = !selectedItem.checked;
    if (selectedConnectionStatus.value === "Select All") {
      connectionsStatuses.forEach((x) => (x.checked = selectedItem.checked));
    } else {
      const activeItems = connectionsStatuses.filter(
        (x) => x.checked && x.value !== "Select All",
      );

      if (activeItems.length < 3) {
        connectionsStatuses.find((x) => x.value === "Select All").checked =
          false;
      } else if (activeItems.length === 3) {
        connectionsStatuses.find((x) => x.value === "Select All").checked =
          true;
      }
    }

    const allData = [...clonedData];

    const selectedConnectionStatuses = [];

    connectionsStatuses.forEach((x) => {
      if (x.value !== "Select All" && x.checked) {
        selectedConnectionStatuses.push(x.value.toLowerCase());
      }
    });

    const filteredData = allData.filter((x) =>
      selectedConnectionStatuses.includes(
        x.ClientInformationArray[0].ConnectionStatus[0].Value.toLowerCase(),
      ),
    );
    setData(filteredData);
    setConnectionStatuses(connectionsStatuses);
  };

  // Remove Select filter when clicking outside card
  const removeSelectedFilter = () => {
    if (selectedFilter === "Permissions") {
      if (
        clickedData &&
        clickedData.offsetParentClasses &&
        !clickedData.offsetParentClasses.contains("radios-groups") &&
        !clickedData.offsetParentClasses.contains("MuiRadio-root")
      ) {
        setFilter(null);
      }
    } else if (selectedFilter === "Connection Status") {
      if (
        clickedData &&
        clickedData.offsetParentClasses &&
        !clickedData.offsetParentClasses.contains("checkboxes-form") &&
        !clickedData.offsetParentClasses.contains("Mui-checked") &&
        !clickedData.offsetParentClasses.contains("MuiCheckbox-root")
      ) {
        if (clickedData.offsetParentId !== "tableHeader") {
          setFilter(null);
        }
      }
    } else if (editDialogItem && !isEditDialogItemOpen && !dialogData) {
      setEditDialogItem(null);
    } else if (editDialogItem && isEditDialogItemOpen) {
      setEditDialogItemOpen(false);
    }

    if (
      selectedPermission &&
      clickedData &&
      clickedData.classes &&
      !clickedData.classes.contains("permission_icon")
    ) {
      setSelectedPermission(null);
    }
  };

  const openEditDialog = (data, index) => {
    setEditDialogItemOpen(true);
    setEditDialogItem({
      index,
      data,
    });
  };

  // Send Push Notifiation and Email for client when he is connected
  const sendConnectedClientInfo = (selectedClient) => {
    // buildfire.notifications.pushNotification.schedule(
    //   {
    //     title: 'Your Dashboard is Ready',
    //     text: 'Clinician approved your connection request and your dashboard is now ready',
    //     users: [selectedClient.ClientId]
    //   },
    //   (err, result) => {
    //     if (err) return console.error(err);
    //   }
    // );
    props.openMail(selectedClient);
    filterData(null, "search", keyword);
    setConnectionStatuses(connectionStatuses);
    setPermissionFilter(permissionFilter);
    setSelectedPermission(null);
  };

  const selectPermission = (rowIndex, permissionIndex) => {
    setSelectedPermission({
      rowIndex,
      permissionIndex,
    });
  };

  const changeStatusCall = (status) => {
    const _data = [...data];
    const selectedClient = _data[editDialogItem.index];
    const values = selectedClient.PrcsParmtrValueTwo.replace(
      /[\[\]\s"]/g,
      "",
    ).split(",");
    const hasConnect = values.includes("Connect");
    const hasDisconnect = values.includes("Disconnect");

    ClientAccess.changeConnectionStatus(selectedClient.ClientId, status).then(
      () => {
        if (hasConnect && !hasDisconnect) {
          if (status === "Connect") {
            sendConnectedClientInfo(selectedClient);
          }
        } else {
          filterData(null, "search", keyword);
          setConnectionStatuses(connectionStatuses);
          setPermissionFilter(permissionFilter);
          setSelectedPermission(null);
        }
      },
    );
  };

  const handleClose = () => {
    setIsDialogOpen(false);
    setDialogData(null);
  };

  const handleConfirm = () => {
    changeStatusCall("Disconnect");
    setDialogData(null);
    setIsDialogOpen(false);
  };

  const changeClientStatus = (status, itemIndex) => {
    const _data = [...data];
    const selectedData = _data[itemIndex];
    if (status === "Disconnect") {
      setDialogData({
        title: "DISCONNECT CLIENT",
        message: "Are you sure you want to disconnect this client?",
        confirmButton: {
          text: "Disconnect",
          type: "primary",
        },
      });
      setIsDialogOpen(true);
    } else {
      changeStatusCall(status);
    }

    if (status === "Connect") {
      toast.success(
        `You are connected to ${selectedData.ClientInformationArray[0]["Preferred Name"][0].Value}. You can now set their recommendations!`,
        {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        },
      );

      // Hardcoded
      selectedData.ClientInformationArray[0].ConnectionStatus[0].VisualName =
        "Body 1";
      selectedData.ClientInformationArray[0].ConnectionStatus[0].VisualType =
        "Middle Green";
    }

    setData(_data);
  };

  // When Clicking on User Info, We navigate to Triskele Clinician Plugin
  const goToDashboard = (row) => {
    const connectionStatus =
      row.ClientInformationArray[0].ConnectionStatus[0].Value;
    if (connectionStatus.toLowerCase() === "pending") {
      toast.warning("Client is pending. You cannot access their data yet!", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
      });
    } else if (connectionStatus.toLowerCase() === "disconnected") {
      toast.warning("Client is disconnected. You cannot access their data!", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
      });
    } else {
      // window.clientId = row.ClientId;
      navigate("/home/dashboard?clientid=" + row.ClientId, {
        clientId: row.ClientId,
      });
    }
  };

  const updateSearchKeyWord = debounce((e) => {
    setKeyword(e.target.value);
    setSkeleton(false);
    filterData(null, "search", e.target.value);
  }, 200);

  return (
    <div style={{ marginBottom: "80px", height: "100%" }}>
      {header && <ProfileHeader header={header} />}
      <SearchCard
        setAction={updateSearchKeyWord}
        placeholder="Find Client by Name, Preferred Name or Connection Status"
      />
      <TableContainer
        className="client-list-container"
        component={Paper}
        style={{ height: "100%" }}
      >
        <Table
          sx={{ minWidth: 650 }}
          id="clients-table"
          size="small"
          aria-label="a dense table"
        >
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "100px" }} />
              {(!columns || !columns.ColumnHeaderArray) && <EmptyData />}

              {columns &&
                columns.ColumnHeaderArray &&
                columns.ColumnHeaderArray.map((header, index) => (
                  <TableCell id="tableHeader" key={header + "_" + index}>
                    <div
                      className="row-flex column-gap-16 align-center justify-center"
                      onClick={() => filterData(header.ColumnName, index)}
                      aria-hidden
                      // Need To Add header.columnType
                    >
                      <label
                        className={`margin-0 ${classNameTriskeleParser(columns.VisualNameTwo, columns.VisualTypeTwo, "Text")} `}
                      >
                        {header.ColumnName}
                      </label>
                      <Icon
                        classNames={`size-35 custom_icon_size ${classNameTriskeleParser(header.VisualName, header.VisualType, "Icon")}`}
                      />
                    </div>
                    {selectedFilter === "Permissions" &&
                      header.ColumnName === "Permissions" && (
                        <div
                          className="dialog_items left-20"
                          style={{ width: "100%" }}
                        >
                          {selectedPermissionFilter &&
                            selectedPermissionFilter.map(
                              (permission, index) => (
                                <FormControl className="radios-groups">
                                  <label className={Body3400C}>
                                    {permission.titleText}
                                  </label>
                                  <RadioGroup
                                    className="radios-groups"
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    name="radio-buttons-group"
                                    style={{ marginLeft: "16px" }}
                                    defaultValue={permission.value}
                                    onChange={(e) =>
                                      filterByPermissions(index, e.target.value)
                                    }
                                  >
                                    <FormControlLabel
                                      className={`radio-group ${Body3300N}`}
                                      value="All"
                                      size="small"
                                      control={<Radio />}
                                      label="All"
                                    />
                                    <FormControlLabel
                                      className={`radio-group ${Body3300N}`}
                                      value="Enabled"
                                      size="small"
                                      control={<Radio />}
                                      label="Enabled"
                                    />
                                    <FormControlLabel
                                      className={`radio-group ${Body3300N}`}
                                      value="Disabled"
                                      size="small"
                                      control={<Radio />}
                                      label="Disabled"
                                    />
                                  </RadioGroup>
                                </FormControl>
                              ),
                            )}
                        </div>
                      )}
                    {selectedFilter === "Connection Status" &&
                      header.ColumnName === "Connection Status" && (
                        <div
                          className="dialog_items left-20 checkboxes-form"
                          style={{ width: "100%" }}
                        >
                          {connectionStatus &&
                            connectionStatus.map((connStatus) => (
                              <FormControlLabel
                                onChange={() => {
                                  filterByConnectionStatus(connStatus);
                                }}
                                control={<Checkbox className="checkboxes" />}
                                style={{ marginLeft: "5px" }}
                                className={`checkbox-item ${Body3300C}`}
                                label={connStatus.value}
                                checked={connStatus.checked}
                              />
                            ))}
                        </div>
                      )}
                  </TableCell>
                ))}
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {skeleton && <ClientSkeleton />}
            {!skeleton && data && data.length === 0 && (
              <TableRow id="emptyStateRow">
                <TableCell style={{ position: "absolute", top: "35%" }}>
                  {connectionStatus.find((x) => !x.checked) ||
                  permissionFilter.some((x) => x.value !== "All") ||
                  keyword ? (
                    <EmptyState
                      title="No data"
                      body1="Try with different criteria."
                    />
                  ) : (
                    <EmptyState
                      title="You don't have any clients connected yet"
                      body1="Click on '+' button to invite a client."
                      body2="List of your clients will appear here when they send you connection request"
                    />
                  )}
                </TableCell>
              </TableRow>
            )}
            {!skeleton &&
              data &&
              data.length > 0 &&
              data.map((row, index) => (
                <TableRow key={index}>
                  <TableCell
                    style={{
                      margin: "auto",
                      display: "flex",
                      opacity:
                        row.ClientInformationArray[0].ConnectionStatus[0]
                          .Value === "Disconnected"
                          ? 0.4
                          : 1,
                    }}
                    className="client-profile-img text-center"
                  >
                    {row.ProfilePicture && (
                      <img
                        alt="profile"
                        className="client-profile-img"
                        src={row.ProfilePicture}
                      />
                    )}
                    {!row.ProfilePicture && (
                      <Icon classNames={`size-50 ${EMPTY_PROFILE_PIC}`} />
                    )}
                  </TableCell>
                  <TableCell
                    className="text-center"
                    style={{
                      opacity:
                        row.ClientInformationArray[0].ConnectionStatus[0]
                          .Value === "Disconnected"
                          ? 0.4
                          : 1,
                    }}
                  >
                    <label
                      className={classNameTriskeleParser(
                        row.ClientInformationArray[0]["Last Name"][0]
                          .VisualName,
                        row.ClientInformationArray[0]["Last Name"][0]
                          .VisualType,
                        "Text",
                      )}
                      onClick={() => goToDashboard(row)}
                    >
                      {row.ClientInformationArray[0]["Last Name"][0].Value}
                    </label>
                  </TableCell>
                  <TableCell
                    className="text-center"
                    style={{
                      opacity:
                        row.ClientInformationArray[0].ConnectionStatus[0]
                          .Value === "Disconnected"
                          ? 0.4
                          : 1,
                    }}
                  >
                    <label
                      className={classNameTriskeleParser(
                        row.ClientInformationArray[0]["First Name"][0]
                          .VisualName,
                        row.ClientInformationArray[0]["First Name"][0]
                          .VisualType,
                        "Text",
                      )}
                      onClick={() => goToDashboard(row)}
                    >
                      {row.ClientInformationArray[0]["First Name"][0].Value}
                    </label>
                  </TableCell>
                  <TableCell
                    className="text-center"
                    style={{
                      opacity:
                        row.ClientInformationArray[0].ConnectionStatus[0]
                          .Value === "Disconnected"
                          ? 0.4
                          : 1,
                    }}
                  >
                    <label
                      className={classNameTriskeleParser(
                        row.ClientInformationArray[0]["Preferred Name"][0]
                          .VisualName,
                        row.ClientInformationArray[0]["Preferred Name"][0]
                          .VisualType,
                        "Text",
                      )}
                      onClick={() => goToDashboard(row)}
                    >
                      {row.ClientInformationArray[0]["Preferred Name"][0].Value}
                    </label>
                  </TableCell>
                  <TableCell
                    className="text-center"
                    style={{
                      opacity:
                        row.ClientInformationArray[0].ConnectionStatus[0]
                          .Value === "Disconnected"
                          ? 0.4
                          : 1,
                    }}
                  >
                    <PermissionsCard
                      selectPermission={selectPermission}
                      selectedPermission={selectedPermission}
                      rowIndex={index}
                      permissions={row.ClientInformationArray[0].Permissions}
                    />
                  </TableCell>
                  <TableCell
                    className="text-center"
                    style={{
                      opacity:
                        row.ClientInformationArray[0].ConnectionStatus[0]
                          .Value === "Disconnected"
                          ? 0.4
                          : 1,
                    }}
                  >
                    <label
                      className={classNameTriskeleParser(
                        row.ClientInformationArray[0].ConnectionStatus[0]
                          .VisualName,
                        row.ClientInformationArray[0].ConnectionStatus[0]
                          .VisualType,
                        "Text",
                      )}
                    >
                      {row.ClientInformationArray[0].ConnectionStatus[0].Value}
                    </label>
                  </TableCell>
                  <TableCell>
                    <div>
                      <div
                        onClick={() => openEditDialog(row, index)}
                        className="pencil-icon-container"
                      >
                        <Icon classNames={`size-35 ${EDIT_ICON}`} />
                      </div>
                      {editDialogItem && editDialogItem.index === index && (
                        <div
                          className={`dialog_items right-1 mt-12 left-150 ${OffWhiteBackground}`}
                          style={{ bottom: "0" }}
                        >
                          {editDialogItem.data.PrcsParmtrValueTwo?.replace(
                            /\[|\]/g,
                            "",
                          )
                            .split(",")
                            .map((action, index) => (
                              <Button
                                key={index}
                                variant="text"
                                onClick={() =>
                                  changeClientStatus(action, index)
                                }
                              >
                                <div
                                  className={
                                    action === "Connect"
                                      ? BODY_TEXT_NAVY_2
                                      : TextRegularS
                                  }
                                >
                                  {action}
                                </div>
                              </Button>
                            ))}
                        </div>
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            <TableRow style={{ height: "80px" }} />
          </TableBody>
        </Table>
      </TableContainer>

      <div style={{ padding: "8px" }} className="client-list-mobile-container">
        {skeleton && <ClientListSkeletonMobile />}
        {!skeleton && data && data.length === 0 && (
          <EmptyState title="No data" body1="" />
        )}
        {!skeleton &&
          data &&
          data.length > 0 &&
          data.map((row, index) => (
            <Card
              key={index}
              variant="outlined"
              sx={{
                mb: 2,
                opacity:
                  row.ClientInformationArray[0].ConnectionStatus[0].Value ===
                  "Disconnected"
                    ? 0.4
                    : 1,
                position: "relative",
              }}
            >
              <CardContent>
                {/* Profile Image */}
                <div
                  className="flex items-center gap-3 mb-2"
                  style={{
                    display: "flex",
                    gap: "10px",
                    opacity:
                      row.ClientInformationArray[0].ConnectionStatus[0]
                        .Value === "Disconnected"
                        ? 0.4
                        : 1,
                  }}
                >
                  {row.ProfilePicture ? (
                    <img
                      alt="profile"
                      src={row.ProfilePicture}
                      style={{ width: 50, height: 50, borderRadius: "50%" }}
                    />
                  ) : (
                    <Icon classNames={`size-50 ${EMPTY_PROFILE_PIC}`} />
                  )}
                  <div>
                    <Typography
                      variant="h6"
                      className={classNameTriskeleParser(
                        row.ClientInformationArray[0]["Last Name"][0]
                          .VisualName,
                        row.ClientInformationArray[0]["Last Name"][0]
                          .VisualType,
                        "Text",
                      )}
                      onClick={() => goToDashboard(row)}
                    >
                      {row.ClientInformationArray[0]["First Name"][0].Value}{" "}
                      {row.ClientInformationArray[0]["Last Name"][0].Value}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ mt: 1 }}
                      onClick={() => goToDashboard(row)}
                    >
                      Preferred Name:{" "}
                      <b>
                        {
                          row.ClientInformationArray[0]["Preferred Name"][0]
                            .Value
                        }
                      </b>
                    </Typography>
                  </div>
                </div>

                <Divider />

                <div
                  style={{
                    width: "auto",
                    marginTop: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <div style={{ marginTop: "10px" }}>
                      <PermissionsCardMobile
                        selectPermission={selectPermission}
                        selectedPermission={selectedPermission}
                        rowIndex={index}
                        permissions={row.ClientInformationArray[0].Permissions}
                      />
                    </div>

                    <Typography
                      variant="body2"
                      sx={{ mt: 1 }}
                      style={{ marginTop: "10px", marginLeft: "8px" }}
                    >
                      Status:{" "}
                      <b
                        className={classNameTriskeleParser(
                          row.ClientInformationArray[0].ConnectionStatus[0]
                            .VisualName,
                          row.ClientInformationArray[0].ConnectionStatus[0]
                            .VisualType,
                          "Text",
                        )}
                      >
                        {
                          row.ClientInformationArray[0].ConnectionStatus[0]
                            .Value
                        }
                      </b>
                    </Typography>
                  </div>
                  <div className="flex gap-2 mt-2">
                    <div
                      onClick={() => openEditDialog(row, index)}
                      className="pencil-icon-container"
                    >
                      <Icon classNames={`size-35 ${EDIT_ICON}`} />
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
      </div>
      {dialogData && (
        <Dialog
          open={isDialogOpen}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{dialogData.title}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {dialogData.message}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={handleConfirm} autoFocus>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
}
